import { atom } from 'jotai'

export const userAtom = atom({ loggedIn : false, canSee : [""], canEdit : [""], _id : "", person : null})